import React, { useState } from "react";

const DiscountComponent = ({
    isDiscountAbove,
    onPositionChanged,
    onValueChanged,
    onTypeChanged,
    discountType,
    discountValue,
    discountAmount,
    discountRowAmount,
    componentTax }) => {

    return (
        <div className="container mx-auto p-4">
            <div className="flex mb-4">
                <label className="block text-gray-600 font-medium">Diskon dihitung setelah pajak?</label>
                <div className="ml-4">
                    <label className="flex items-center cursor-pointer">
                        <input
                            type="checkbox"
                            checked={isDiscountAbove}
                            onChange={(e) => {
                                onPositionChanged(e.target.checked);
                            }}
                            className="toggle-checkbox"
                        />
                    </label>
                </div>
            </div>



            {!isDiscountAbove && (
                <div className="mb-4">
                    <div className="flex justify-between">
                        <label className="block text-gray-600 font-medium mb-2">Diskon per baris</label>
                        <p>Rp{discountRowAmount.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</p>
                    </div>
                    <div className="border-t-2 border-dashed border-gray-300 my-2"></div>
                    <p>Diskon</p>
                    <div className="flex justify-between space-x-2">
                        <div className="flex border border-gray-300 rounded-md bg-white focus-within:ring-2 focus-within:ring-blue-400">
                            <select
                                value={discountType}
                                onChange={onTypeChanged}
                                className="bg-transparent text-gray-700 p-2 focus:outline-none"
                            >
                                <option value="%">%</option>
                                <option value="Rp">Rp</option>
                            </select>
                            <input
                                type="number"
                                value={discountValue}
                                onChange={onValueChanged}
                                className="flex-1 p-2 bg-transparent focus:outline-none"
                            />
                        </div>
                        <p>Rp{discountAmount.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</p>
                    </div>
                    <div className="border-t-2 border-dashed border-gray-300 my-2"></div>
                </div>
            )}

            {componentTax}

            {isDiscountAbove && (
                <div className="mb-4">
                    <div className="border-t-2 border-dashed border-gray-300 my-2"></div>
                    <div className="flex justify-between">
                        <label className="block text-gray-600 font-medium mb-2">Diskon per baris</label>
                        <p>Rp{discountRowAmount.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</p>
                    </div>
                    <div className="border-t-2 border-dashed border-gray-300 my-2"></div>
                    <p>Diskon</p>
                    <div className="flex justify-between space-x-2">                                                
                        <div className="flex border border-gray-300 rounded-md bg-white focus-within:ring-2 focus-within:ring-blue-400">
                            <select
                                value={discountType}
                                onChange={onTypeChanged}
                                className="bg-transparent text-gray-700 p-2 focus:outline-none"
                            >
                                <option value="%">%</option>
                                <option value="Rp">Rp</option>
                            </select>
                            <input
                                type="number"
                                value={discountValue}
                                onChange={onValueChanged}
                                className="flex-1 p-2 bg-transparent focus:outline-none"
                            />
                        </div>
                        <p>Rp{discountAmount.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DiscountComponent;
